import { useCallback, useEffect, useRef } from 'react'
import { Node } from '@react-types/shared'
import { ListCollection } from '@react-stately/list'
import { Item, useCollection } from '@react-stately/collections'
import { ProgressStatusCollectionProps, ProgressStatusItemProps } from 'components/ProgressStatus/Types'
import { ProgressStatusList } from 'components/ProgressStatus/ProgressStatusList'
import { filterDOMProps, mergeProps } from '@react-aria/utils'
import { ProgressStatus } from 'components/ProgressStatus/ProgressStatus'
import { ProgressHandle } from 'screens/Campaign/ReviewCampaignModal/Analysing/Types'

export const ProgressStatusItem: <T>(props: ProgressStatusItemProps<T>) => JSX.Element = Item

export const ProgressStatusCollection = <T extends object>({ children, ...rest }: ProgressStatusCollectionProps<T>) => {
  const factory = useCallback((nodes: Iterable<Node<T>>) => new ListCollection(nodes), [])
  const collection = useCollection<T>({ children }, factory, { suppressTextValueWarning: true })

  const collectionItemsRef = useRef<ProgressHandle[]>([])

  useEffect(() => {
    collectionItemsRef.current[0]?.start()
  }, [])

  return (
    <ProgressStatusList {...filterDOMProps(rest, { labelable: true })}>
      {[...collection].map((item, index) => {
        return (
          <ProgressStatus
            key={item.key}
            {...mergeProps(item.props, { onDone: () => collectionItemsRef.current[index + 1]?.start() })}
            ref={(node) => {
              if (node) {
                collectionItemsRef.current[index] = node
              }
            }}>
            {item.rendered}
          </ProgressStatus>
      )})}
    </ProgressStatusList>
  )
}
